(function () {
  function sortContainer(container) {
    if (!container) return;

    const items = Array.from(container.querySelectorAll('[data-available]'));
    if (items.length < 2) return;

    const available = [];
    const soldout = [];

    for (const el of items) {
      (el.getAttribute('data-available') === 'true' ? available : soldout).push(el);
    }

    // Evita mexer se já estiver ordenado
    const alreadySorted =
      items.slice(0, available.length).every((el) => el.getAttribute('data-available') === 'true') &&
      items.slice(available.length).every((el) => el.getAttribute('data-available') === 'false');

    if (alreadySorted) return;

    const frag = document.createDocumentFragment();
    for (const el of available) frag.appendChild(el);
    for (const el of soldout) frag.appendChild(el);
    container.appendChild(frag);
  }

  function init() {
    const container = document.querySelector('[data-product-container]');
    if (!container) return;

    // Ordena no load inicial
    sortContainer(container);

    // Observa inserts do infinite load
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          sortContainer(container);
          break;
        }
      }
    });

    observer.observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
